import React from 'react';
import './index.less';

interface WelcomeProps {
  onFeatureClick?: (feature: string) => void;
}

export const Welcome: React.FC<WelcomeProps> = () => {
  return (
    <div className="welcome-message">
      <div className="ai-intro">
        <div className="greeting">
          <span className="wave-emoji">👋🏻 </span>
          <span className="greeting-text">Hi，我是您的AI 助理</span>
        </div>
        <p className="intro-text">
        我将随时为您提供帮助。让您的每一天更轻松、更有趣。
        </p>
      </div>
    </div>
  );
};

export default Welcome; 